// 2026-09: 'admin'이 pastoral_admin(사역 관리자)/deacon_admin(재정 관리자·안수집사)으로
// 분리되었다. 두 역할은 서로의 계정/데이터 영역을 건드릴 수 없다 — 실제 강제는 항상
// 백엔드(utils/adminGuard.js 등)가 하며, 여기 있는 헬퍼들은 화면에서 미리 안내/버튼
// 비활성화용으로만 쓰는 것이다.

export const PASTORAL_DOMAIN_ROLES = ['pastoral_admin', 'pastor', 'leader'];
// 'jikje'(제직) — 2026-09 추가. deacon(안수집사)과 같은 재정 진영 소속 세부 역할.
// 'jikje_admin'(집사 관리자) — 2026-09 추가. deacon_admin과 완전히 동등한 재정 진영
// 관리자 역할(재정 화면 전체 접근 + 재정 진영 전체 계정 관리).
export const FINANCE_DOMAIN_ROLES  = ['deacon_admin', 'jikje_admin', 'finance', 'deacon', 'jikje'];

export const isPastoralAdmin = (role) => role === 'pastoral_admin';
export const isDeaconAdmin   = (role) => role === 'deacon_admin' || role === 'jikje_admin';
export const isAnyAdmin      = (role) => role === 'pastoral_admin' || role === 'deacon_admin' || role === 'jikje_admin';

export const domainOf = (role) => {
  if (PASTORAL_DOMAIN_ROLES.includes(role)) return 'pastoral';
  if (FINANCE_DOMAIN_ROLES.includes(role)) return 'finance';
  return null;
};

// 2026-09: deacon_admin(재정 관리자)을 jikje_admin(집사 관리자)으로 통합했으므로,
// pastoral_admin이 반대 진영 admin을 처음 부트스트랩할 때 지정하는 역할도
// jikje_admin으로 바꾼다.
export const opponentAdminOf = (adminRole) => (adminRole === 'pastoral_admin' ? 'jikje_admin' : 'pastoral_admin');

// 2026-09: 한 계정이 재정 진영의 세부 역할(안수집사/제직/헌금·재정담당)을 동시에
// 여러 개 겸임할 수 있게 한 기능(migrations/090) — "제직이면서 안수집사이자 재정도
// 담당하는 사람이 있다"는 요청. user.role(주 역할) 외에 user.extra_roles(겸임 역할
// 배열)를 함께 갖고 있을 수 있다. 겸임은 이 3개 세부 역할 사이에서만 허용된다.
export const FINANCE_SUB_ROLES = ['deacon', 'jikje', 'finance'];

// user가 role이든 extra_roles든 어떤 형태로든 해당 역할을 "가지고" 있는지 —
// 화면 곳곳의 role==='deacon' 같은 단순 비교를 겸임까지 반영하도록 대체한다.
export const hasRole = (user, role) =>
  user?.role === role || (Array.isArray(user?.extra_roles) && user.extra_roles.includes(role));

// user가 가진 모든 역할(주 역할 + 겸임 역할)의 배열.
export const effectiveRolesOf = (user) => {
  const base = user?.role ? [user.role] : [];
  const extra = Array.isArray(user?.extra_roles) ? user.extra_roles : [];
  return [...new Set([...base, ...extra])];
};

// 로그인한 사용자(actor)가 대상 계정(targetRole)을 관리(수정/비활성화/역할변경 등)할 수
// 있는지에 대한 화면 표시용 사전 판단 — 최종 판단은 항상 서버가 한다.
export const canManageTarget = (actorRole, targetRole, isSuperAdmin = false) => {
  if (isSuperAdmin) return true;
  if (!isAnyAdmin(actorRole)) return false;
  return domainOf(actorRole) === domainOf(targetRole);
};
